import { httpsCallable } from 'firebase/functions';
import { functions, isFirebaseConfigured } from './client';

/**
 * Calls a Firebase callable Cloud Function and returns its data payload.
 * @param {string} functionName Callable function name.
 * @param {Record<string, unknown>} payload Function input data.
 * @returns {Promise<any>} Function response payload.
 */
export async function callCloudFunction(functionName, payload = {}) {
  if (!isFirebaseConfigured || !functions) {
    throw new Error('Firebase is not configured. Add REACT_APP_FIREBASE_* values to .env.');
  }

  const callable = httpsCallable(functions, functionName);
  const result = await callable(payload);
  return result.data;
}
